import { Link } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import { useTranslation } from "react-i18next";

// Componente de Bot Card reutilizável
export const BotCard = ({ bot, onVote }) => {
  const { t } = useTranslation();

  return (
    <div className={`bot-slate-card ${bot.apiTier === "premium" ? "premium" : bot.apiTier === "business" ? "business" : ""}`}>
      {bot.verified && <div className="bot-verified-marker">✓</div>}

      {/* Módulo 1: Identidade Visual */}
      <div className="module-identity">
        <div className="avatar-container">
          <img src={bot.avatar} alt={bot.name} />
        </div>
        {bot.apiTier !== "free" && <span className={`slate-tier-tag ${bot.apiTier}`}>{bot.apiTier.toUpperCase()}</span>}
      </div>

      {/* Módulo 2: Informações e Conteúdo */}
      <div className="module-content">
        <div className="content-header">
          <h3 className="slate-bot-name">{bot.name}</h3>
          <div className="slate-stats-row">
            <div className="slate-stat">
              <svg className="icon-tiny stars" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
              <span>{bot.rating}</span>
            </div>
            <div className="slate-stat">
              <svg className="icon-tiny servers" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
              </svg>
              <span>{bot.servers >= 1000 ? `${(bot.servers / 1000).toFixed(1)}K` : bot.servers}</span>
            </div>
          </div>
        </div>

        <p className="slate-description">{bot.description}</p>

        <div className="slate-tags">
          {bot.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="slate-tag">
              #{tag}
            </span>
          ))}
        </div>
      </div>

      {/* Módulo 3: Painel de Ações */}
      <div className="module-actions">
        <button
          className="slate-btn-vote"
          onClick={() => {
            trackEvent("click_vote_init", {
              bot_id: bot.id,
              bot_name: bot.name,
            });
            onVote && onVote(bot);
          }}
        >
          ▲ {bot.votes >= 1000 ? `${(bot.votes / 1000).toFixed(1)}K` : bot.votes}
        </button>

        <div className="slate-secondary-actions">
          <Link
            to={`/bots/${bot.id}`}
            className="slate-btn-icon"
            title={t("botCard.viewDetails")}
            onClick={() =>
              trackEvent("bot_view_details", {
                bot_id: bot.id,
                bot_name: bot.name,
              })
            }
          >
            🔍
          </Link>
          <Link
            to={`https://discord.com/oauth2/authorize?client_id=${bot.id}&permissions=8&integration_type=0&scope=bot+applications.commands`}
            target="_blank"
            rel="noopener noreferrer"
            className="slate-btn-icon btn-add"
            title={t("botCard.invite")}
            onClick={() =>
              trackEvent("bot_add_click", {
                bot_id: bot.id,
                bot_name: bot.name,
              })
            }
          >
            {t("botCard.addButton")}
          </Link>
        </div>
      </div>
    </div>
  );
};

// Componente de Sidebar Bot Item
export const SidebarBotItem = ({ bot }) => {
  const { t } = useTranslation();

  return (
    <Link to={`/bots/${bot.id}`} className="text-decoration-none text-white" onClick={() => trackEvent("sidebar_bot_click", { bot_id: bot.id, bot_name: bot.name })}>
      <div className="sidebar-bot-item">
        <div className="sidebar-bot-avatar">
          <img src={bot.avatar} alt={bot.name} />
        </div>
        <div className="sidebar-bot-info">
          <div className="sidebar-bot-name">
            {bot.name}
            {bot.apiTier === "premium" && <span className="sidebar-tier premium">⭐</span>}
            {bot.apiTier === "business" && <span className="sidebar-tier business">🚀</span>}
          </div>
          <div className="sidebar-bot-stat">
            ⭐ {bot.rating} • {bot.votes === 1 ? t("botCard.votesCount", { count: bot.votes }) : t("botCard.votesCountPlural", { count: bot.votes })}
          </div>
        </div>
      </div>
    </Link>
  );
};
